import { createFileRoute } from "@tanstack/react-router"

import { interiorPackagesSearchSchema } from "@/features/interior-packages/interior-packages-search-schema"
import { requirePermission } from "@/lib/route-guards"
import { Perm } from "@/lib/permissions"
import { InteriorPackagesPage } from "@/pages/interior-packages/interior-packages-page"

export const Route = createFileRoute("/_authenticated/settings/interior-packages")({
	validateSearch: (search) => interiorPackagesSearchSchema.parse(search),
	beforeLoad: async ({ context }) => {
		// Ungated read: viewers may browse read-only, same as Archived Projects.
		await requirePermission(context, Perm.PROJECT_READ, { to: "/settings/general" })
	},
	component: InteriorPackagesPage,
})
